/* ============================================
   SEVRA — Main JavaScript
============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // ── GALLERY THUMBNAIL SWITCHER ──
  document.querySelectorAll('.pdp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.querySelector('img').src;
      var mainImg = document.querySelector('.pdp-gallery__main img');
      if (mainImg) mainImg.src = src;
      document.querySelectorAll('.pdp-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ── BUNDLE SELECTOR ──
  document.querySelectorAll('.bundle-card').forEach(function(card) {
    card.addEventListener('click', function() {
      document.querySelectorAll('.bundle-card').forEach(function(c) { c.classList.remove('selected'); });
      this.classList.add('selected');
    });
  });

  // ── ACCORDION ──
  document.querySelectorAll('.accordion-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = this.nextElementSibling;
      var icon = this.querySelector('.accordion-icon');
      var open = body.style.display === 'block';
      body.style.display = open ? 'none' : 'block';
      if (icon) icon.textContent = open ? '+' : '×';
    });
  });

  // ── FAQ ACCORDION ──
  document.querySelectorAll('.faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var body = this.nextElementSibling;
      var icon = this.querySelector('.faq-icon');
      var open = body.style.display === 'block';
      body.style.display = open ? 'none' : 'block';
      if (icon) icon.textContent = open ? '+' : '×';
      if (item) item.classList.toggle('open', !open);
    });
  });

  // ── AJAX ADD TO CART ──
  var addToCartBtn = document.querySelector('.btn-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var btn = this;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.innerHTML = '✓ Added to Cart';
        btn.style.background = '#1A35B5';
        setTimeout(function() {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
        // Update cart count
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.querySelector('.cart-count');
            if (countEl) countEl.textContent = cart.item_count;
          });
      })
      .catch(function() {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
      });
    });
  }

  // ── NEWSLETTER FORM ──
  var emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = this.querySelector('input[type="email"]');
      var btn = this.querySelector('button');
      if (!input || !input.value) return;
      btn.textContent = 'Subscribed!';
      input.value = '';
      setTimeout(function() { btn.textContent = 'Subscribe'; }, 3000);
    });
  }

});
